import React from "react";

export default function SQL_Aggregate_Functions() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Aggregate_Functions</h1>
      <p>This is the SQL_Aggregate_Functions component generated from the SQL JSON.</p>
    </div>
  );
}
